"use client";

import { Check } from "@/components/icons";
import { Skeleton } from "@/components/ui/Skeleton";
import { Text } from "@/components/ui/Text";
import { useFreeShippingCost } from "@/lib/centra/hooks";
import { classed } from "@frend-digital/ui";
import { useTranslations } from "next-intl";
import styles from "./index.module.css";

const Circle = classed("span", styles.circle);

export const ShippingInfo = () => {
	const t = useTranslations("product");

	const { isLoading, error, freeShippingCost, freeShippingCurrency } =
		useFreeShippingCost();
	return (
		<div className={styles.root}>
			<FreeShippingPrice />

			<Text className={styles.text} variant="utility4" weight={500}>
				<Circle>
					<Check />
				</Circle>
				{t("deliveryTime")}
			</Text>
		</div>
	);
};

const FreeShippingPrice = () => {
	const t = useTranslations("product");

	const { isLoading, error, freeShippingCost, freeShippingCurrency } =
		useFreeShippingCost();

	if (isLoading) {
		return (
			<div style={{ display: "flex", margin: "0 auto", gap: "5px" }}>
				<Skeleton fitContent>
					<Circle />
				</Skeleton>
				<Skeleton fitContent>
					<Text className={styles.text} variant="utility4" weight={500}>
						Free shipping over 2500 NOK
					</Text>
				</Skeleton>
			</div>
		);
	}

	if (error) return null;
	return (
		<Text className={styles.text} variant="utility4" weight={500}>
			<Circle>
				<Check />
			</Circle>
			{`${t("shippingCost")} ${freeShippingCost} ${freeShippingCurrency}`}
		</Text>
	);
};
